// Category Record Class

import * as Utils from "@/utils/utils";

export default class CatRec {

	constructor(dat) {
		const src			= dat || {};

		this.rid		= src.rid		|| 0;
		this.itemId		= src.item_id	|| "";
		this.sortKey	= src.sort_key	|| "";
		this.pub		= src.pub		|| "";
		this.title		= src.title		|| "";
		this.descr		= src.descr		|| "";
		this.icoMin		= src.ico_min	|| "";
		this.icoMid		= src.ico_mid	|| "";
		this.icoMax		= src.ico_max	|| "";

	}


}
